import { useContext } from "react";
import { LanguageContext } from "./LanguageContext";
import { SupportedLanguage } from "./translations";
import { TranslationKeys } from "./translations/en";

export const useTranslation = () => {
  const context = useContext(LanguageContext);

  if (!context) {
    throw new Error("useTranslation must be used within a LanguageProvider");
  }

  const { language, setLanguage, t } = context;

  // Helper function to replace placeholders in strings
  const translate = (
    text: string,
    params?: Record<string, string | number>
  ): string => {
    if (!params) return text;

    let result = text;
    Object.keys(params).forEach((key) => {
      result = result.replace(
        new RegExp(`\\{${key}\\}`, "g"),
        String(params[key])
      );
    });
    return result;
  };

  return {
    language,
    setLanguage,
    t,
    translate,
  };
};
